import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ArchiveIcon from '@material-ui/icons/Archive';
import { useNotify, useRefresh } from 'react-admin';
import { AppRole } from '@vatos-pas/common';

import ConfirmDialog from 'components/ConfirmDialog';
import { PermissionsProvider } from 'providers/permissionsProvider';
import { axiosInstance } from 'services/http';
import { MasterSheetContainer } from '../containers';

const ArchiveJobButton: React.FC = () => {
  const { selectedJob, setSelectedJob } = MasterSheetContainer.useContainer();
  const { hasRole } = PermissionsProvider.useContainer();
  const notify = useNotify();
  const refresh = useRefresh();
  const [prompt, setPrompt] = useState<'idle' | 'confirming' | 'saving'>(
    'idle',
  );

  if (!selectedJob || !hasRole([AppRole.RegionalAdmin, AppRole.SuperAdmin])) {
    return null;
  }

  const closePrompt = () => {
    if (prompt !== 'saving') setPrompt('idle');
  };

  const archive = async () => {
    if (prompt !== 'confirming' || selectedJob.job.archived) return;

    const jobId = selectedJob.job.id;
    setPrompt('saving');
    try {
      await axiosInstance.post(`/job/${jobId}/archive`);
      setSelectedJob(current =>
        current?.job.id === jobId
          ? { ...current, job: { ...current.job, archived: true } }
          : current,
      );
      notify('Job has been Archived successfully');
      refresh();
    } catch {
      notify('Something went wrong. Please try again.', 'warning');
    } finally {
      setPrompt('idle');
    }
  };

  return (
    <>
      {selectedJob.job.archived ? (
        <Button variant="contained" disabled>
          Archived
        </Button>
      ) : (
        <IconButton
          aria-label="Archive Job"
          style={{ color: '#f44336' }}
          onClick={() => setPrompt('confirming')}
          disabled={prompt === 'saving'}
        >
          <ArchiveIcon />
        </IconButton>
      )}
      <ConfirmDialog
        open={prompt !== 'idle'}
        title="Are you sure you want to Archive this Job?"
        handleClose={closePrompt}
        onConfirm={archive}
        disabled={prompt === 'saving'}
      />
    </>
  );
};

export default ArchiveJobButton;
